import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userinfo: localStorage.getItem('userinfo') ? JSON.parse(localStorage.getItem('userinfo')) : {},
    nowIndex: Cookies.get('nowIndex') || 0,
    xiaonum: Cookies.get('xiaonum') || 0,
    xtxiaonum: Cookies.get('xiaonum') || 0,
    kfxiaonum: Cookies.get('kfxiaonum') || 0,
    isplay: false,
    load: false,
    isload: Cookies.get('isload') ? Cookies.get('isload') : 1
  },
  getters: {
  },
  mutations: {
    Setisload(state, value) {
      Cookies.set('isload', value)
      state.isload = value
    },
    Setisplay(state, value) {
      state.isplay = value
      let music = ''
      //music = document.getElementById("audio");
      if (state.isplay) {
        if (!state.load) {
          document.addEventListener(
            "touchstart",
            function () {
              //music.play();
            },
            false
          );
        } else {
          //music.play()
        }
      } else {
        audio.load()
      }
      state.load = true
    },
    SetUserinfo(state, value) {
      localStorage.setItem('userinfo', JSON.stringify(value))
      state.userinfo = value
    },
    SetNowIndex(state, value) {
      Cookies.set('nowIndex', value)
      state.nowIndex = value
    },
    SetXiaonum(state, value) {
      Cookies.set('xiaonum', value)
      state.xiaonum = value
    },
    SetXtxiaonum(state, value) {
      Cookies.set('xtxiaonum', value)
      state.xtxiaonum = value
    },
    SetKfxiaonum(state, value) {
      Cookies.set('kfxiaonum', value)
      state.kfxiaonum = value
    },
  },
  actions: {
  },
  modules: {
  }
})
